import { createAsyncThunk } from '@reduxjs/toolkit';
import { getNotificationList, postNotificationViewed } from '../../../api/notification/notificationService';


export const getNotificationListThunk = createAsyncThunk(
  'notification/getNotificationList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getNotificationList();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const postNotificationViewedThunk = createAsyncThunk(
  'notification/postNotificationViewed',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await postNotificationViewed(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);


